import {useAuthStore} from "~/stores/auth";

export const useAuth = () => {
    const authData = useState('auth', () => {
        return {
            isLoggedIn: false,
            displayName: '',
            firstName: '',
            phoneNumber: '',
            profileImage: '',
            email: '',
            username: '',

            enrollsCount: 0,
            qaaCount: 0,
            ticketsCount: 0,
            sessionCount: 0,
            walletBalance: 0,
        }
    })

    const authStore = useAuthStore();
    const fetchUser = async () => {

    }

    const initAuth = async () => {
        if (import.meta.server) return;

        const token = useCookie('auth_token')?.value || null;
        if (token){
            authStore.setAuthLoading(true);
            authStore.setToken(token);
            const { data, error } = await useApi('/v1/profile?stats=1', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (error.value){
                authStore.clearToken();
                authStore.setAuthLoading(false);
                window.location.href = 'https://sabzlearn.ir/login'
                return;
            }
            authStore.setUser(data.value?.data);
            authStore.setAuthLoading(false);


            authData.value.isLoggedIn = true
            authData.value.firstName = data.value?.data.first_name
            authData.value.displayName = data.value?.data.display_name
            authData.value.phoneNumber = data.value?.data.mobile
            authData.value.profileImage = data.value?.data.avatar.url
            authData.value.email = data.value?.data.email
            authData.value.username = data.value?.data.username


            authData.value.enrollsCount = data.value?.data.stats.enrolls || 0
            authData.value.qaaCount = data.value?.data.stats.qa || 0
            authData.value.ticketsCount = data.value?.data.stats.tickets || 0
            authData.value.sessionCount = data.value?.data.stats.transactions || 0

        } else {
            authStore.clearToken();
            window.location.href = 'https://sabzlearn.ir/login'
        }

    }

    async function logout(){
        const { data, error } = await useApi('/v1/auth/logout', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${authStore.token}`
            }
        })
        if (error.value) return useApiErrorHandler(error.value);
        authStore.logout()
        window.location.reload();
    }


    return {
        initAuth,
        logout
    }
}